import { Link, NavLink } from "react-router-dom";
import { ShoppingCart, Compass } from "lucide-react";
import { useCart } from "../context/CartContext";

export const Navbar = () => {
  const { totals } = useCart();
  const linkCls = ({ isActive }) =>
    `text-sm tracking-wide transition-colors ${isActive ? "text-white" : "text-white/60 hover:text-white"}`;

  return (
    <nav
      data-testid="site-navbar"
      className="sticky top-0 z-50 bg-[#040914]/85 backdrop-blur-xl border-b border-[#1E2D4A] h-20 flex items-center"
    >
      <div className="max-w-7xl mx-auto px-6 w-full flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <Compass className="w-5 h-5 text-white group-hover:rotate-45 transition-transform duration-500" strokeWidth={1.5} />
          <span className="font-heading text-lg tracking-[0.18em] uppercase">Mon Dessinateur BTP</span>
        </Link>

        <div className="hidden md:flex items-center gap-10">
          <NavLink to="/" end className={linkCls} data-testid="nav-accueil">Accueil</NavLink>
          <NavLink to="/articles" className={linkCls} data-testid="nav-articles">Articles</NavLink>
          <NavLink to="/contact" className={linkCls} data-testid="nav-contact">Contact</NavLink>
          <NavLink to="/devis" className={linkCls} data-testid="nav-devis">
            <span className="inline-flex items-center gap-2">
              <ShoppingCart className="w-4 h-4" strokeWidth={1.5} />
              Devis
              {totals.count > 0 && (
                <span
                  data-testid="cart-count-badge"
                  className="ml-1 bg-white text-black text-[10px] font-semibold px-2 py-0.5"
                >
                  {totals.count}
                </span>
              )}
            </span>
          </NavLink>
        </div>
      </div>
    </nav>
  );
};
